/* ROOMS · головна
   1. Речі без тла для стрічок на фото кампейну і блоків на рожевому. Сайт нічого не вирізає сам.
      Стрічка з data-rooms-mix (сторінка сертифіката) після перевірки фото розкладає речі по черзі за видами й брендами.
      Береться підготовлений PNG з прозорим тлом, у назві файлу якого є «cutout»; якщо його немає, перше з
      п’яти перших фото товару, яке вже прозоре і де сама річ, без моделі. Порожні поля обрізаються.
      Товар без такого фото в стрічках на кампейнах показується карткою з першим фото (data-cutout-card),
      у решті блоків не показується. Перше фото вже з прозорим тлом (вирізане в CRM) — картка без рожевої
      плашки (.is-clear): людина стоїть просто на фото кампейну.
   2. Пара в русі: смуга внизу показує назву й ціну речі під курсором; кнопка паузи.
      Галерея пар ([data-rooms-pair-gallery], більше двох блоків): слайди змінюються самі раз на data-interval
      секунд (лінія часу в перемикачі; кінець її анімації = наступний слайд). Наведення, пауза в будь-якому
      слайді, вихід секції з екрана і прихована вкладка зупиняють зміну; на телефоні гортається пальцем;
      у редакторі теми вибір блоку відкриває його слайд.
   3. Ряди товарів гортаються перетягуванням мишею; перетягування не вважається кліком.
   4. Ряд «спочатку нові» підвантажує найсвіжіші плитки через sections/rooms-sorted-tiles.liquid;
      закріплена перша плитка (наприклад, сертифікат) лишається на місці й не дублюється.
   5. Образ: рядок списку і плитка тієї самої речі підсвічують одне одного.
   6. Усі бренди: біля курсора з’являється сіра плитка з річчю бренду; фото вантажаться при першому наведенні на список.
   7. Стан магазину за київським часом ([data-rooms-hours], сторінка «Контакти»): «зараз відчинено · до 20:00»
      із зеленою крапкою або «відчинимо о 10:00»; перевіряється щохвилини.
   8. «Читати повністю» для довгого тексту про бренд під сіткою колекції: текст увесь у коді сторінки,
      згорнутий лише візуально; кнопка з’являється, тільки якщо текст справді не вміщається.
   9. Рекомендації на картці товару (sections/recommended-products.liquid): підвантажуються з /recommendations/products
      і показуються сіткою плиток; якщо їх немає, секція зникає.
   10. Instagram (sections/rooms-instagram.liquid): у #insta-feed пишуть два скрипти Instafeed. Старий (ScriptTag 16.8)
       отримує від свого API 401 і перед перевіркою відповіді очищає контейнер, стираючи стрічку нового (19.x).
       Якщо контейнер спорожнів після того, як у ньому вже були дописи, повертаємо ті самі вузли назад.
   11. Instagram зі CRM ([data-rooms-insta], джерело «CRM» у секції): коли секція наближається до екрана (за 800px),
       запит до стрічки CRM (?n=кількість плиток) заповнює плитки посиланнями на дописи; фото проявляється після
       завантаження. Помилка або порожній список ховають стрічку, заголовок лишається.
   Розмітка: sections/rooms-*.liquid, snippets/rooms-cutout-item.liquid. Стилі: assets/rooms-home.css. */
(function () {
  if (window.roomsHome) return;
  window.roomsHome = true;

  /* ---------- 1. речі з прозорим тлом ---------- */
  var cache = {};

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = url;
    });
  }

  /* Сайт нічого не вирізає й не чіпає краї речі: лише знаходить фото, яке вже без тла, і обрізає порожні
     прозорі поля, щоб речі в стрічці стояли рівно.
     - Позначена вирізка (у назві файлу є «cutout») береться без перевірок.
     - Інакше фото годиться, якщо тло прозоре, річ не торкається країв кадру, а для одягу це не людина
       на повний зріст (у каталозі є прозорі фото з моделями). Фото з білим тлом пропускаються. */
  function cut(img, opts) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return null;
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    var data;
    try { data = ctx.getImageData(0, 0, w, h); } catch (e) { return opts.trusted ? img.src : null; }
    var p = data.data, x, y;
    function clear(px, py) { return p[(py * w + px) * 4 + 3] < 24; }

    if (!opts.trusted) {
      var sides = [[0, 0, 1, 0, w], [0, h - 1, 1, 0, w], [0, 0, 0, 1, h], [w - 1, 0, 0, 1, h]];
      for (var s = 0; s < 4; s++) {
        var n = 0, ok = 0;
        for (var t = 0; t < sides[s][4]; t += 2) { n++; if (clear(sides[s][0] + t * sides[s][2], sides[s][1] + t * sides[s][3])) ok++; }
        if (ok / n < 0.97) return null;
      }
    }

    /* межі речі */
    var minX = w, minY = h, maxX = -1, maxY = -1, filled = 0;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        if (p[(y * w + x) * 4 + 3] > 20) {
          filled++;
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    var cw = maxX - minX + 1, ch = maxY - minY + 1;
    if (!opts.trusted && opts.wear && (ch / cw > 2.2 || filled / (cw * ch) < 0.4)) return null;

    var out = document.createElement('canvas');
    out.width = cw;
    out.height = ch;
    out.getContext('2d').drawImage(img, minX, minY, cw, ch, 0, 0, cw, ch);
    return new Promise(function (resolve) {
      if (out.toBlob) out.toBlob(function (b) { resolve(b ? URL.createObjectURL(b) : out.toDataURL('image/png')); }, 'image/png');
      else resolve(out.toDataURL('image/png'));
    });
  }

  function cutoutFrom(list, opts) {
    var key = list.join('|');
    if (cache[key]) return cache[key];
    cache[key] = (function next(k) {
      if (k >= list.length) return Promise.resolve(null);
      return loadImage(list[k]).then(function (im) { return cut(im, opts); }, function () { return null; }).then(function (url) {
        return url || next(k + 1);
      });
    })(0);
    return cache[key];
  }

  /* черга, щоб не навантажувати телефон: по три фото одночасно */
  var jobs = [], running = 0;
  function pump() {
    while (running < 3 && jobs.length) {
      var job = jobs.shift();
      running++;
      job.run().then(function () { running--; pump(); }, function () { running--; pump(); });
    }
  }
  /* річ, на яку щойно навели, обробляється одразу, поза чергою */
  function bump(img) {
    for (var i = 0; i < jobs.length; i++) {
      if (jobs[i].img === img) {
        var job = jobs.splice(i, 1)[0];
        running++;
        job.run().then(function () { running--; pump(); }, function () { running--; pump(); });
        return;
      }
    }
  }

  /* Фото картки вже без тла (вирізане в CRM)? Тоді плашка під ним не потрібна: людина стоїть просто на кампейні.
     Мірка — верхні кути кадру прозорі: на фото з білим тлом вони білі, а на вирізаному порожні */
  function clearGround(url) {
    return loadImage(url).then(function (im) {
      var w = 48, h = Math.max(1, Math.round(w * im.naturalHeight / Math.max(1, im.naturalWidth)));
      var c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(im, 0, 0, w, h);
      var p;
      try { p = ctx.getImageData(0, 0, w, h).data; } catch (e) { return false; }
      function corner(x0) {
        for (var y = 0; y < 4; y++) {
          for (var x = x0; x < x0 + 4; x++) {
            if (p[(y * w + x) * 4 + 3] > 24) return false;
          }
        }
        return true;
      }
      return corner(0) || corner(w - 4);
    }, function () { return false; });
  }

  function processCut(img) {
    if (img.dataset.cutState) return;
    img.dataset.cutState = 'queued';
    var list = (img.dataset.cutout || '').split('|').filter(Boolean).map(function (u) { return u.indexOf('//') === 0 ? location.protocol + u : u; });
    jobs.push({ img: img, run: function () {
      return cutoutFrom(list, { trusted: img.dataset.cutoutTrusted === '1', wear: img.classList.contains('rooms-cut--wear') }).then(function (url) {
        var item = img.closest('.rooms-rail__item, .rooms-mo__item, .rooms-bc__img');
        if (!url && img.dataset.cutoutCard) {
          var card = img.dataset.cutoutCard;
          if (card.indexOf('//') === 0) card = location.protocol + card;
          img.classList.add('rooms-cut--card');
          if (item) item.classList.add('is-card');
          return clearGround(card).then(function (clear) {
            if (clear && item) item.classList.add('is-clear');
            return card;
          });
        }
        return url;
      }).then(function (url) {
        var item = img.closest('.rooms-rail__item, .rooms-mo__item, .rooms-bc__img');
        if (!url) {
          img.dataset.cutState = 'failed';
          if (item) item.hidden = true;
          var failedRail = img.closest('[data-rooms-rail]');
          if (failedRail) fillRail(failedRail);
          return;
        }
        img.onload = function () {
          img.classList.add('is-ready');
          var rail = img.closest('[data-rooms-rail]');
          if (rail) fillRail(rail);
          var grid = img.closest('[data-rooms-max]');
          if (grid) capGrid(grid);
        };
        img.src = url;
        img.dataset.cutState = 'done';
      });
    } });
    pump();
  }

  /* сітка показує не більше data-rooms-max готових речей, у порядку колекції */
  function capGrid(grid) {
    var max = +grid.dataset.roomsMax || 8, n = 0;
    grid.querySelectorAll('.rooms-mo__item').forEach(function (el) {
      var img = el.querySelector('.rooms-cut');
      if (!img || img.dataset.cutState === 'failed') return;
      if (img.classList.contains('is-ready')) {
        n++;
        el.hidden = n > max;
      }
    });
  }

  /* мікс (стрічка на сторінці сертифіката, data-rooms-mix="N"): коли відомо, які речі справді без тла, ставимо їх
     по черзі за видами (data-kind: одяг, сумка, годинник, взуття, аксесуар), не більше data-rooms-mix-brand одного
     бренду (data-brand) і не більше N усього; решту ховаємо. Друга половина стрічки — копія першої в тому ж порядку. */
  var MIX_ORDER = ['wear', 'bag', 'time', 'shoe', 'acc'];
  function mixRail(rail, halves) {
    var max = +rail.dataset.roomsMix || 0, perBrand = +rail.dataset.roomsMixBrand || 2;
    var own = function (h) { return Array.prototype.filter.call(h.children, function (el) { return !el.dataset.roomsClone; }); };
    var first = own(halves[0]), second = own(halves[1]);
    var buckets = {}, used = {}, out = [];
    first.forEach(function (el, i) {
      var it = { el: el, twin: second[i], kind: el.dataset.kind || 'wear', brand: el.dataset.brand || '' };
      if (!el.hidden) (buckets[it.kind] = buckets[it.kind] || []).push(it);
      else if (it.twin) it.twin.hidden = true;
    });
    var kinds = MIX_ORDER.concat(Object.keys(buckets).filter(function (k) { return MIX_ORDER.indexOf(k) < 0; }));
    var moved = true;
    while (out.length < max && moved) {
      moved = false;
      kinds.forEach(function (k) {
        var b = buckets[k];
        while (out.length < max && b && b.length) {
          var it = b.shift();
          if ((used[it.brand] || 0) >= perBrand) continue;
          used[it.brand] = (used[it.brand] || 0) + 1;
          out.push(it);
          moved = true;
          break;
        }
      });
    }
    first.forEach(function (el, i) {
      var keep = out.some(function (it) { return it.el === el; });
      if (!keep) { el.hidden = true; if (second[i]) second[i].hidden = true; }
    });
    out.forEach(function (it) {
      halves[0].appendChild(it.el);
      if (it.twin) halves[1].appendChild(it.twin);
    });
  }

  /* стрічка мусить бути ширшою за кадр, інакше в колі видно порожнечу: якщо речей мало, повторюємо їх */
  function fillRail(rail) {
    var halves = rail.querySelectorAll('.rooms-rail__half');
    if (halves.length !== 2) return;
    var pending = rail.querySelectorAll('img[data-cutout]:not([data-cut-state="done"]):not([data-cut-state="failed"])').length;
    if (pending) return;
    if (rail.dataset.roomsMix && !rail.dataset.roomsMixed) {
      rail.dataset.roomsMixed = '1';
      mixRail(rail, halves);
    }
    var base = Array.prototype.filter.call(halves[0].children, function (el) { return !el.hidden && !el.dataset.roomsClone; });
    if (!base.length) { rail.hidden = true; return; }
    var guard = 0;
    while (halves[0].scrollWidth < rail.clientWidth * 1.05 && guard++ < 6) {
      base.forEach(function (el) {
        [0, 1].forEach(function (h) {
          var c = el.cloneNode(true);
          c.dataset.roomsClone = '1';
          c.setAttribute('tabindex', '-1');
          c.setAttribute('aria-hidden', 'true');
          halves[h].appendChild(c);
        });
      });
    }
  }

  /* фото обробляються, коли блок наближається до екрана */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.querySelectorAll('img[data-cutout]').forEach(processCut);
    });
  }, { rootMargin: '600px 0px' }) : null;

  /* ---------- 2. пара в русі ---------- */
  function initMotion(mo) {
    var bar = mo.querySelector('.rooms-mo__bar');
    var pause = mo.querySelector('.rooms-mo__pause');
    if (pause) {
      pause.addEventListener('click', function () {
        var on = mo.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (!bar) return;
    var a = bar.children[0], b = bar.children[1];
    function rest() { bar.classList.remove('is-item'); a.textContent = bar.dataset.a; b.textContent = bar.dataset.b; }
    mo.querySelectorAll('.rooms-mo__item').forEach(function (el) {
      function show() { bar.classList.add('is-item'); a.textContent = el.dataset.n; b.textContent = el.dataset.p; }
      el.addEventListener('mouseenter', show);
      el.addEventListener('focus', show);
      el.addEventListener('mouseleave', rest);
      el.addEventListener('blur', rest);
    });
  }

  /* ---------- 2а. галерея пар ---------- */
  function initPairGallery(sec) {
    var slides = Array.prototype.slice.call(sec.querySelectorAll('.rooms-pair__slide'));
    var dots = Array.prototype.slice.call(sec.querySelectorAll('.rooms-pair__dot'));
    if (slides.length < 2) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, leaveTimer = null;
    sec.style.setProperty('--gal-t', (+sec.dataset.interval || 7) + 's');

    function run(i) {
      dots.forEach(function (d, k) {
        d.classList.remove('is-run');
        d.classList.toggle('is-done', k < i);
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (reduced || !dots[i]) return;
      void dots[i].offsetWidth;
      dots[i].classList.add('is-run');
    }

    function go(i) {
      i = (i + slides.length) % slides.length;
      if (i === cur) return;
      var prev = slides[cur], next = slides[i];
      clearTimeout(leaveTimer);
      slides.forEach(function (sl) { sl.classList.remove('is-leaving', 'is-entering'); });
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.setAttribute('inert', '');
      next.removeAttribute('inert');
      next.classList.add('is-active');
      if (!reduced) next.classList.add('is-entering');
      leaveTimer = setTimeout(function () {
        prev.classList.remove('is-leaving');
        next.classList.remove('is-entering');
      }, reduced ? 0 : 1300);
      cur = i;
      /* пауза діє на всі слайди однаково */
      var paused = sec.classList.contains('is-paused');
      next.querySelectorAll('.rooms-mo').forEach(function (mo) { mo.classList.toggle('is-paused', paused); });
      run(i);
    }

    /* лінія часу дійшла до кінця: наступний слайд */
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
      d.querySelector('i').addEventListener('animationend', function () { if (k === cur) go(cur + 1); });
    });

    /* наведення тримає слайд; пауза в будь-якому слайді зупиняє і рух, і зміну */
    sec.addEventListener('mouseenter', function () { sec.classList.add('is-hold'); });
    sec.addEventListener('mouseleave', function () { sec.classList.remove('is-hold'); });
    sec.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.rooms-mo__pause');
      if (!btn) return;
      var on = btn.closest('.rooms-mo').classList.contains('is-paused');
      sec.classList.toggle('is-paused', on);
      sec.querySelectorAll('.rooms-mo').forEach(function (mo) {
        mo.classList.toggle('is-paused', on);
        var b = mo.querySelector('.rooms-mo__pause');
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    /* поза екраном і в прихованій вкладці час не йде */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sec.classList.toggle('is-off', !e.isIntersecting); });
      }, { threshold: 0.25 }).observe(sec);
    }
    document.addEventListener('visibilitychange', function () { sec.classList.toggle('is-hold', document.hidden); });

    /* телефон: гортання пальцем */
    var sx = null, sy = null;
    sec.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* редактор теми: вибраний блок показує свій слайд і тримає його */
    document.addEventListener('shopify:block:select', function (e) {
      var sl = e.target.closest && e.target.closest('.rooms-pair__slide');
      if (!sl || !sec.contains(sl)) return;
      go(slides.indexOf(sl));
      sec.classList.add('is-hold');
    });
    document.addEventListener('shopify:block:deselect', function () { sec.classList.remove('is-hold'); });

    run(0);
  }

  /* ---------- 3. ряди гортаються перетягуванням ---------- */
  var drag = null, dragged = false;
  window.addEventListener('mousemove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 4) { dragged = true; drag.el.classList.add('is-drag'); }
    drag.el.scrollLeft = drag.left - dx;
  });
  window.addEventListener('mouseup', function () {
    if (!drag) return;
    drag.el.classList.remove('is-drag');
    drag = null;
    setTimeout(function () { dragged = false; }, 0);
  });
  function initDrag(track) {
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      drag = { el: track, x: e.clientX, left: track.scrollLeft };
      dragged = false;
      e.preventDefault();
    });
    track.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- 4. ряд «спочатку нові»: свіжі плитки з колекції, відсортованої за датою ---------- */
  /* handle товару з посилання плитки: /products/gift-card і /collections/x/products/gift-card?variant=1 — одне й те саме */
  function productKey(a) {
    var path = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
    var i = path.indexOf('/products/');
    return i < 0 ? path : path.slice(i + 10);
  }

  function initSorted(row) {
    var url = row.dataset.roomsSorted;
    function done() { row.classList.remove('is-pending'); }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* закріплена перша плитка (rooms-tile--pinned) лишається на місці, а з нових прибираємо її дубль */
        var pinned = row.querySelector('.rooms-tile--pinned .rooms-tile__link');
        var pinnedKey = pinned ? productKey(pinned) : '';
        var fresh = Array.prototype.slice.call(doc.querySelectorAll('.rooms-sorted > .rooms-tile')).filter(function (t) {
          var a = t.querySelector('.rooms-tile__link');
          return !pinnedKey || !a || productKey(a) !== pinnedKey;
        });
        var old = Array.prototype.slice.call(row.querySelectorAll('.rooms-tile:not(.rooms-tile--pinned)'));
        old.forEach(function (tile, i) {
          var next = fresh[i];
          if (!next) return;
          next = document.importNode(next, true);
          /* велика плитка лишає свій клас і заголовок */
          if (tile.classList.contains('rooms-tile--lead')) {
            next.classList.add('rooms-tile--lead');
            var head = tile.querySelector('.rooms-tile__head');
            if (head) next.insertBefore(head, next.firstChild);
          }
          var img = next.querySelector('.rooms-tile__img img');
          var oldImg = tile.querySelector('.rooms-tile__img img');
          if (img && oldImg) img.setAttribute('sizes', oldImg.getAttribute('sizes') || '');
          tile.parentNode.replaceChild(next, tile);
        });
      })
      .catch(function () {})
      .then(done, done);
  }

  /* ---------- 5. образ: рядок списку і плитка підсвічують одне одного ---------- */
  function initLook(look) {
    look.querySelectorAll('[data-look]').forEach(function (el) {
      var n = el.dataset.look;
      function set(on) { look.querySelectorAll('[data-look="' + n + '"]').forEach(function (x) { x.classList.toggle('is-hot', on); }); }
      el.addEventListener('mouseenter', function () { set(true); });
      el.addEventListener('mouseleave', function () { set(false); });
    });
  }

  /* ---------- 6. усі бренди: річ бренду біля курсора ---------- */
  function initBrands(sec) {
    var float = sec.querySelector('.rooms-brands__float');
    if (!float || !window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    var list = sec.querySelector('.rooms-brands__list');
    var started = false, x = -999, y = -999, fx = -999, fy = -999, raf = null, on = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() {
      if (started) return;
      started = true;
      float.querySelectorAll('img[data-src]').forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
      });
    }
    function loop() {
      fx += (x - fx) * (reduced ? 1 : 0.18);
      fy += (y - fy) * (reduced ? 1 : 0.18);
      float.style.setProperty('--fx', Math.round(fx) + 'px');
      float.style.setProperty('--fy', Math.round(fy) + 'px');
      raf = Math.abs(x - fx) + Math.abs(y - fy) > 0.5 ? requestAnimationFrame(loop) : null;
    }
    function move(e) {
      /* плитка стоїть під курсором праворуч, щоб не закривати саму назву; біля правого краю екрана
         переходить ліворуч, а біля нижнього краю стає над курсором */
      var w = float.offsetWidth, h = float.offsetHeight;
      x = e.clientX + 28 + w > window.innerWidth ? e.clientX - 28 - w : e.clientX + 28;
      y = e.clientY + 44 + h > window.innerHeight ? e.clientY - 44 - h : e.clientY + 44;
      if (fx < -900) { fx = x; fy = y; }
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function show(i) {
      if (on) on.classList.remove('is-on');
      on = i === null ? null : float.querySelector('.rooms-brands__pic[data-brand="' + i + '"]');
      if (on) on.classList.add('is-on');
    }
    list.addEventListener('mouseenter', start);
    list.addEventListener('mousemove', move);
    list.addEventListener('mouseleave', function () { show(null); });
    list.querySelectorAll('a[data-brand]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.dataset.brand); });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-rooms-duo], [data-rooms-mo], .rooms-bc-row').forEach(function (el) {
      if (el.dataset.roomsInit) return;
      el.dataset.roomsInit = '1';
      if (io) io.observe(el); else el.querySelectorAll('img[data-cutout]').forEach(processCut);
    });
    root.querySelectorAll('[data-rooms-mo]').forEach(function (mo) { if (!mo.dataset.roomsMo) { mo.dataset.roomsMo = '1'; initMotion(mo); } });
    root.querySelectorAll('[data-rooms-pair-gallery]').forEach(function (g) { if (!g.dataset.roomsGalInit) { g.dataset.roomsGalInit = '1'; initPairGallery(g); } });
    root.querySelectorAll('[data-rooms-drag]').forEach(function (t) { if (!t.dataset.roomsDrag) { t.dataset.roomsDrag = '1'; initDrag(t); } });
    root.querySelectorAll('[data-rooms-sorted]').forEach(function (r) { if (!r.dataset.roomsSortedInit) { r.dataset.roomsSortedInit = '1'; initSorted(r); } });
    root.querySelectorAll('[data-rooms-look]').forEach(function (l) { if (!l.dataset.roomsLookInit) { l.dataset.roomsLookInit = '1'; initLook(l); } });
    root.querySelectorAll('[data-rooms-brands]').forEach(function (b) { if (!b.dataset.roomsBrandsInit) { b.dataset.roomsBrandsInit = '1'; initBrands(b); } });
    root.querySelectorAll('[data-rooms-hours]').forEach(function (h) { if (!h.dataset.roomsHoursInit) { h.dataset.roomsHoursInit = '1'; initHours(h); } });
    root.querySelectorAll('[data-rooms-more]').forEach(function (m) { if (!m.dataset.roomsMoreInit) { m.dataset.roomsMoreInit = '1'; initMore(m); } });
    root.querySelectorAll('[data-rooms-recs]').forEach(function (r) { if (!r.dataset.roomsRecsInit) { r.dataset.roomsRecsInit = '1'; initRecs(r); } });
    root.querySelectorAll('.rooms-ig #insta-feed').forEach(function (f) { if (!f.dataset.roomsGuard) { f.dataset.roomsGuard = '1'; guardInsta(f); } });
    root.querySelectorAll('[data-rooms-insta]').forEach(function (b) { if (!b.dataset.roomsInstaInit) { b.dataset.roomsInstaInit = '1'; initInsta(b); } });
  }

  /* ---------- 11. Instagram зі CRM ---------- */
  function initInsta(box) {
    var grid = box.querySelector('.rooms-ig__grid');
    var url = box.getAttribute('data-rooms-insta');
    var count = parseInt(box.getAttribute('data-count'), 10) || 6;
    if (!grid || !url) return;

    function fill(photos) {
      if (!photos.length) { box.classList.add('is-failed'); return; }
      var tiles = grid.children;
      for (var i = 0; i < tiles.length; i++) {
        var li = tiles[i], p = photos[i];
        if (!p) { li.hidden = true; continue; }
        li.classList.remove('is-empty');
        li.removeAttribute('aria-hidden');
        var a = document.createElement('a');
        a.href = p.link;
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-label', p.alt ? 'Instagram: ' + p.alt : 'Допис в Instagram');
        var img = new Image();
        img.alt = p.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 640;
        img.height = 640;
        img.onload = function () { this.classList.add('is-loaded'); };
        img.src = p.img;
        a.appendChild(img);
        li.appendChild(a);
      }
    }

    function load() {
      var sep = url.indexOf('?') < 0 ? '?' : '&';
      fetch(url + sep + 'n=' + count, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { fill((d && d.photos) || []); })
        .catch(function () { box.classList.add('is-failed'); });
    }

    if (!('IntersectionObserver' in window)) { load(); return; }
    var obs = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      load();
    }, { rootMargin: '800px 0px' });
    obs.observe(box);
  }

  /* ---------- 7. стан магазину ---------- */
  function kyivHour() {
    var zones = ['Europe/Kyiv', 'Europe/Kiev'];
    for (var i = 0; i < zones.length; i++) {
      try {
        return parseInt(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone: zones[i] }).format(new Date()), 10);
      } catch (e) {}
    }
    return new Date().getHours();
  }

  function initHours(el) {
    var label = el.querySelector('[data-rooms-hours-label]');
    function update() {
      var h = kyivHour(), from = +el.getAttribute('data-open'), to = +el.getAttribute('data-close');
      var open = from < to ? h >= from && h < to : h >= from || h < to;
      el.classList.toggle('is-online', open);
      if (label) label.textContent = el.getAttribute(open ? 'data-label-open' : 'data-label-closed');
    }
    update();
    setInterval(update, 60000);
  }

  /* ---------- 8. «читати повністю» ---------- */
  function initMore(body) {
    var box = body.closest('section') || body.parentNode;
    var btn = box.querySelector('[data-rooms-more-toggle]');
    if (!btn) return;
    function check() {
      if (body.classList.contains('is-open')) return;
      var clamped = body.scrollHeight > body.clientHeight + 24;
      body.classList.toggle('is-clamped', clamped);
      btn.hidden = !clamped;
    }
    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        body.classList.remove('is-clamped');
      } else {
        check();
        box.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
    btn.setAttribute('aria-expanded', 'false');
    check();
    window.addEventListener('resize', check);
  }

  /* ---------- 9. рекомендації ---------- */
  function initRecs(section) {
    var url = section.getAttribute('data-rooms-recs');
    var box = section.querySelector('[data-recommendations]');
    if (!url || !box) return;
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.rooms-tile')) {
        box.innerHTML = fresh.innerHTML;
      } else {
        section.hidden = true;
      }
    }).catch(function () { section.hidden = true; });
  }

  /* ---------- 10. Instagram: не даємо старому скрипту Instafeed стерти стрічку ---------- */
  function guardInsta(feed) {
    var saved = null;
    new MutationObserver(function () {
      if (feed.children.length) {
        saved = Array.prototype.slice.call(feed.childNodes);
      } else if (saved && saved.length) {
        saved.forEach(function (node) { feed.appendChild(node); });
      }
    }).observe(feed, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* редактор теми перемальовує секції */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
